import React, { useCallback, useState } from "react";
import { PieChart, Pie, Sector, Cell, Legend } from "recharts";

// const data = [
//     { name: 'Mobile', value: 400 },
//     { name: 'Desktop', value: 300 }
//   ];

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    value
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey+4}
        textAnchor={textAnchor}
        fill={fill}
      >{`${value}`}</text>
    </g>
  );
};

export default function CustomPieChart(props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );
  return (
    <PieChart width={props.width} height={props.height}>
      <Legend
          height={36}
          iconType="line"
          layout="horizontal"
          verticalAlign="bottom"
          iconSize={15}
          padding={10}
        />
      <Pie
        activeIndex={activeIndex}
        activeShape={renderActiveShape}
        data={props.data}
        cx={props.cx}
        cy={props.cy}
        innerRadius={50}
        outerRadius={55}
        fill="#5FAE8A"
        dataKey="value"
        paddingAngle={props.data.length > 1 ? 5 : 0}
        onMouseEnter={onPieEnter}
      />
      {props.data.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.fill} />
      ))}
      {props.innerText > 0 ?
        <text x={props.cx} y={props.cy+5} dy={8} dx={5} textAnchor="middle" fill={"#475467"} className="text-2xl">
          {props.innerText}
        </text> :
        <></>
      }
    </PieChart>
  );
}
